import { DefaultTheme } from 'styled-components';

const theme: DefaultTheme = {
  colors: {
    white: '#ffffff',
    black: '#000000',
    lightBlue: '#A3D3FF',
    darkBlue: '#190061',
    deepBlue: '#3500D3',
    lightGrey: '#eeeeee',
    grey: '#cccccc',
    midGrey: '#767676',
    darkGrey: '#808080',
    deepGrey: '#343a40',
    darkRed: '#B22222',
    deepRed: '#800000',

    deepGreyTransparent: '#1a1d20a0',

    vmNotification: '#000000',
    vmNotificationBackground: '#FFD700',

    // Semantic status
    success: '#155724',
    successBg: '#d4edda',
    successBorder: '#c3e6cb',
    warning: '#856404',
    warningBg: '#fff3cd',
    warningBorder: '#ffeeba',
    danger: '#721c24',
    dangerBg: '#f8d7da',
    dangerBorder: '#f5c6cb',
    info: '#004085',
    infoBg: '#cce5ff',
    infoBorder: '#b8daff',

    // Surface & border
    surface: '#ffffff',
    surfaceElevated: '#f8f9fa',
    border: '#000000',
    borderSubtle: '#cccccc',

    // States
    inputDisabledBg: '#d8d8d8',
    focusRing: '#005fcc',
    // Nav bar is always dark — this token is always white
    navFg: '#ffffff',
    // Semantic action color (buttons, borders): deepGrey in light mode
    actionFg: '#343a40',
    // Button primary background — stays original deep blue in both modes
    buttonPrimaryBg: '#3500D3',
    // Icon filter for dark SVG images on dark backgrounds
    iconFilter: 'none',
  },
  fonts: {
    heading: 'Finlandica',
    body: 'Inter, sans-serif',
  },
  fontSize: {
    xs: '1.2rem',
    sm: '1.4rem',
    base: '1.6rem',
    lg: '1.8rem',
    xl: '2rem',
    '2xl': '2.6rem',
    '3xl': '3.6rem',
    '4xl': '4.8rem',
    hero: '7.6rem',
  },
  lineHeight: {
    tight: '1.1',
    snug: '1.3',
    normal: '1.5',
    relaxed: '1.75',
  },
  letterSpacing: {
    tight: '-0.02em',
    normal: '0',
    wide: '0.02em',
    wider: '0.05em',
  },
  spacing: {
    xs: '0.4rem',
    sm: '0.8rem',
    md: '1.2rem',
    base: '1.6rem',
    lg: '2.4rem',
    xl: '3.2rem',
    '2xl': '4.8rem',
    '3xl': '6.4rem',
  },
  breakpoints: {
    sm: '480px',
    md: '768px',
    lg: '1024px',
    xl: '1280px',
  },
  contentMaxWidth: '90rem',
};

const darkTheme: DefaultTheme = {
  ...theme,
  colors: {
    ...theme.colors,
    // Flip for dark bg: white → dark surface, black → light text
    white: '#1e2227',
    black: '#e8eaed',
    // Surfaces
    surface: '#1a1d22',
    surfaceElevated: '#252b33',
    // Greys
    lightGrey: '#2d3340',
    grey: '#3d4757',
    borderSubtle: '#3d4757',
    border: '#5a6475',
    midGrey: '#9aabb8',
    // deepGrey intentionally NOT overridden — used as nav background (#343a40 stays dark)
    // Input state
    deepGreyTransparent: '#0d1117b0',
    inputDisabledBg: '#2d3340',
    navFg: '#ffffff',
    // Semantic action color (buttons, borders): light in dark mode
    actionFg: '#e8eaed',
    // Invert dark SVG icons to appear light on dark backgrounds
    iconFilter: 'brightness(0) invert(1)',
    // deepBlue links — use light blue for legibility on dark surfaces
    deepBlue: '#A3D3FF',
  },
};

export { theme, darkTheme };
